<template>
  <component :is="homeView" v-if="currentUserLoaded" />
  <page-layout v-else :header="isMobile" :loaded="false" title="Home" />
</template>

<script>
import { mapGetters } from 'vuex';
import { FEATURES } from '@/access/features';

export default {
  name: 'HomeView',
  components: {
    PagesTreeView: () => import('@/views/pages/PagesTreeView.vue'),
    HomeTabsView: () => import('./HomeTabsView.vue'),
  },
  computed: {
    ...mapGetters('users', ['currentUserLoaded']),
    homeView() {
      return this.isFeatureEnabled(FEATURES.PAGES)
        ? 'PagesTreeView'
        : 'HomeTabsView';
    },
  },
};
</script>
